jQuery(function($){
 $('.slick-slider').slick({
        arrows: false,
        dots: false,
        draggable: false,
        pauseOnHover: false,
        slidesToShow: $('.slick-slider').data('rows'),
        vertical: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1023,
                settings:{
                    autoplay: true,
                    vertical: false,
                    centerMode: true,
                    infinite: true,
                    autoplaySpeed: 0,
                    speed: 5000,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    cssEase: 'linear',
                    
                }
            }
        ]
    });

    //Declare Functions

    //Handles footer animation
    function popFooter(el){
        if (el.scrollTop() + el.innerHeight() >= el[0].scrollHeight-15){
            $('.footer').addClass('popped');
        }else{
            $('.footer').removeClass('popped');
        }
    }


    //Get selected layout. Default is grid
    function setLayout(){
        let layout = $('.gallery').attr('data-layout');
        switch (layout){
            case 'grid':
                setGrid();
            break;
            case 'list':
                setList()
                checkTitleFit();
            break;
            default:
                setGrid()
            break;
        }
        
    }
    setLayout();


    //Assigns classes to foundation grid elements for a grid appearance
    function setGrid(){
        $('.gallery').removeClass('is-list').addClass('is-grid').data('layout', 'grid');
        $('.gallery .cell').addClass('medium-6 large-4');
        $('#list-switch').addClass('inactive');
        $('#grid-switch').removeClass('inactive');
    }


    //Assigns classes to foundation grid elements for a list appearance
    function setList(){
        $('.gallery').removeClass('is-grid').addClass('is-list').data('layout', 'list');
        $('.gallery .cell').removeClass('medium-6 large-4');
        $('#grid-switch').addClass('inactive');
        $('#list-switch').removeClass('inactive');
    }


    //Reduces font size of title if it is too long to fit in the container.
    //Some guesswork is needed to estimate the right container size to compare to, .75 works for this specific site.
    //To reduce the number of iterations, increase the decrement/increment value on size per loop. This will result in a faster runtime as n iterations get larger, but will be less precise in fitting the text in it's container.
    function checkTitleFit(){
        $(".gallery .cell").each(function(){
            let title = $('h2', this);
            if(title.length == 0) return;
            if(title[0].offsetWidth > $(this)[0].offsetWidth*.75){
                let size = parseInt(title.css('font-size'));
                while(title[0].offsetWidth > $(this)[0].offsetWidth*.75 && size > 13){
                    size--;
                    let px = size + "px";
                    title.css('font-size', px);
                }
            }else if(title[0].offsetWidth < $(this)[0].offsetWidth*.70){
                let size = parseInt(title.css('font-size'));
                while(title[0].offsetWidth < $(this)[0].offsetWidth*.70 && size < 20){
                    size++;
                    let px = size + "px";
                    title.css('font-size', px);
                }
            }else{
                //No Change
            }
        })
    }

    function toggleProjectDetails(){
        if (viewing){
            overview.removeClass('viewing');
            button.removeClass('viewing');
            overlay.removeClass('viewing');
        }else{
            overview.addClass('viewing');
            button.addClass('viewing');
            overlay.addClass('viewing');
        }
        viewing = !viewing;
    }


    $(document).on('load resize facetwp-loaded', function(){
        setLayout();
    })


    //Handles toggling between grid and list views.
    //Retain layout after facet filter
    $('#grid-switch').on('click', function(){
        $('.gallery').attr('data-layout', 'grid');
        setLayout();
    });
    $('#list-switch').on('click', function () {
        $('.gallery').attr('data-layout', 'list');
        setLayout();
    });



    /* Fullpage */
    new fullpage('#universe', {
        licenseKey: '8E8A3D14-953246EB-B60B284B-CD7084C8',
        normalScrollElements: 'main, .tab, .off-canvas, #post-15',
        sectionSelector: '.test',
        scrollOverflow: true,
        scrollbar: false,
        anchors: ['landing-reel','landing-content'],
        animateAnchor: false,
        afterLoad: function(origin, destination, direction){
            $('.block').addClass('loaded');
            $('#site-copy').addClass('loaded');
            setTimeout(function(){
                $('.home iframe').animate({opacity: 1}, 500);
            }, 2000);
        }
    });

    $('.scroll-reel').on('click', function(){
        fullpage_api.moveSectionUp();
    })
    $('.down-arrow img').on('click', function(){
        fullpage_api.moveSectionDown();
    })


    /* Handles filter toggle click in gallery */
    const facet = $('.filter .facetwp-facet');
    const toggle = $('.filter button')
    let shifted = false;
    toggle.on('click', function ()
    {
        if (shifted)
        {
            facet.removeClass('shifted');
            toggle.removeClass('shifted');
        } else
        {
            facet.addClass('shifted');
            toggle.addClass('shifted');
            oldTop = -1;
        }
        shifted = !shifted;
    });

    /* Handles info toggle click on single project page*/
    const overview = $('.project-overview');
    const button = $('.overview-button');
    const overlay = $('.view-block');
    let viewing = false;
    button.on('click', function (){
        toggleProjectDetails();
    });

    


    /* Controls side pane animations */
    $('.tab.info').on('click', function(){
        $('.menu.off-canvas').removeClass('open');
        //Check if contact tab is already open
        if ($('#os-contact').hasClass('is-open')){
            $('#os-contact').toggleClass('is-open');
            popFooter($(this).siblings('main'));
        }else{
            $('#os-info').toggleClass('is-open');
            popFooter($(this).siblings('main'));
        }
        
    })
    $('.tab.contact').on('click', function(){
        $('.menu.off-canvas').removeClass('open');
        //Check if info tab is already open
        if ($('#os-info').hasClass('is-open')){
            $('#os-contact').toggleClass('is-open');
            popFooter($(this).siblings('main'));
        }else{
            $('#os-info').toggleClass('is-open');
            $('#os-contact').toggleClass('is-open');
            popFooter($(this).siblings('main'));
        }
    })
    //Toggle both Info and Contact to close
    $('.work.tab').on('click', function (){
        $('.menu.off-canvas').removeClass('open');
        if ($('#os-info').hasClass('is-open')){
            $('#os-info').toggleClass('is-open');
        }
        if ($('#os-contact').hasClass('is-open')){
            $('#os-contact').toggleClass('is-open');
        }
        popFooter($('#main'));
    });

    $('main').on('scroll load resize', function (){
        popFooter($(this));
    });
   

    //Toggle Menu animations on mobile
    $('.hamburger').on('click', function(){
        $('.menu.off-canvas').addClass('open');
    })

     $('.close-menu').on('click', function(){
        $('.menu.off-canvas').removeClass('open');
    })


/* 
    Accessible off-canvas toggles 
       Function the same as above
    $('#aria-about-toggle').on('click', function (){
        $('#off-canvas-about .tab').click();
    });
    $('#aria-contact-toggle').on('click', function (){
        $('#off-canvas-contact .tab').click();
    });
*/


    // Change text on Gravity Form submit button on hover
    $('input.button')
        .on('mouseenter',function(){
            $(this).val('Blast Off!');
        })
        .on('mouseleave', function(){
            $(this).val('Make Contact');
        })


    //Restart gifs on hover
    $(document).on('mouseenter', '.gallery .cell', function(e){
        e.preventDefault();
        if($(this).find('video').length > 0){
            $(this).find('video')
                .get(0)
                .play();
        }
    }).on('mouseleave', '.gallery .cell', function(e){
        e.preventDefault();
        if ($(this).find("video").length > 0) {
            $(this).find("video")
                .get(0)
                .pause();
            $(this).find("video")
                .get(0).currentTime = 0;
        };        
    })

    /* Stops vimeo video after closing modal */
    let src = $('iframe').attr('src');
    $('.close-button').on('click', function(){
        let src = $('iframe').attr('src');
        $('iframe').attr('src', '');
    });

    $('.play-wrapper').on('click', function(){
        src += '&autoplay=1&controls=1'
        $('iframe').attr('src', src);
        $('.play-wrapper').toggleClass('watch')
    });
})//End jQuery


